import Vue from 'vue'
import moment from 'moment'
import _ from 'underscore'
import language from '../../build/language/index'
import { maskThousand } from '../utils/numberMasker'
import { conciliationStatusTranslate, taskStatusesTranslate, typeTranslate } from '../utils/statusesTranslator'

moment.locale(language.getDatePickerLanguage())

const getValueByType = (item) => {
  let values = {
    debito: 0.00,
    credito: 0.00,
    saldo: '-'
  }
  switch (item.tipo) {
    case 'D':
      values.debito = item.valor
      break
    case 'C':
      values.credito = item.valor
      break
  }
  return values
}

const generateFinMovFromRow = (row) => {
  let data = row
  let list = []
  window.Grids.Active.ColNames.forEach(groupCol => {
    groupCol.forEach(col => {
      if (col !== 'Check' && col !== 'Acao' && col !== 'Panel' && col !== '_ConstWidth' && col !== '' && col !== 'DSComentario') {
        let typeCol = window.Grids.Active.Cols[col].Type
        let value = null
        if (typeCol === 'Float') {
          // Formatar número
          value = data[col] !== null && data[col] !== '' && data[col] !== ' - ' ? maskThousand(data[col]) : '0,00'
        } else if (typeCol === 'Date') {
          // Formatar data
          value = data[col] ? moment(data[col]).utc().format('L') : ' - '
        } else if (typeCol === 'Enum') {
          // Configurar enum
          if (col === 'Tipo') {
            value = data[col] ? typeTranslate(data[col]) : ' - '
          } else {
            value = data[col] ? conciliationStatusTranslate(data[col]) : ' - '
          }
        } else {
          value = data[col] ? data[col].toString() : ' - '
        }
        let classCss = ''
        if (col === 'VlOriginal') {
          classCss = (row.VlOriginal && row.VlOriginal > 0
            ? 'detail-status font-C'
            : row.VlOriginal && row.VlOriginal < 0
              ? 'detail-status font-D'
              : 'detail-status font-N')
        }
        let obj = {
          title: window.Grids.Active.Header[col],
          value: value,
          order: window.Grids.Active.Cols[col].OrderDetail,
          class: classCss
        }
        list.push(obj)
      }
    })
  })
  list = _.sortBy(list, 'order')
  let $t = Vue.i18n.translate
  return {
    mainValuesList: list,
    commentary: {
      title: $t('modalDetalhesLanc.details.titulos.comentario'),
      value: row.DSComentario ? row.DSComentario : ' - '
    },
    monetaryValuesList: [
      {
        title: $t('modalDetalhesLanc.details.titulos.valorLanc'),
        value: row.VlLancamento ? maskThousand(row.VlLancamento) : '0,00',
        class: row.VlLancamento && row.VlLancamento > 0
          ? 'detail-status font-C'
          : row.VlLancamento && row.VlLancamento < 0
            ? 'detail-status font-D'
            : 'detail-status font-N'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.valorVendaBruto'),
        value: row.VLBRUTO ? maskThousand(row.VLBRUTO) : '0,00',
        class: row.VLBRUTO && row.VLBRUTO > 0
          ? 'detail-status font-C'
          : row.VLBRUTO && row.VLBRUTO < 0
            ? 'detail-status font-D'
            : 'detail-status font-N'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.valorVendaLiq'),
        value: row.VLLIQUIDO ? maskThousand(row.VLLIQUIDO) : '0,00',
        class: row.VLLIQUIDO && row.VLLIQUIDO > 0
          ? 'detail-status font-C'
          : row.VLLIQUIDO && row.VLLIQUIDO < 0
            ? 'detail-status font-D'
            : 'detail-status font-N'
      }
    ],
    statusValuesList: [
      {
        title: $t('modalDetalhesLanc.details.titulos.statusConciliacao'),
        value: conciliationStatusTranslate(row.SituacaoConciliacao),
        class: 'detail-status font-' + (row.SituacaoConciliacao === 'M' ? 'C' : row.SituacaoConciliacao)
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.ocorrencia'),
        value: row.DSMotivoOcorrencia,
        class: 'detail-value'
      }
    ],
    integrationValuesList: [
      {
        title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
        value: moment(row.DtLanc).utc().format('L'),
        class: 'detail-value'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.statusConciliacao'),
        value: conciliationStatusTranslate(row.SituacaoConciliacao),
        class: 'detail-value font-' + (row.SituacaoConciliacao === 'M' ? 'C' : row.SituacaoConciliacao)
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.lote'),
        value: row.IdConciliacaoLote ? row.IdConciliacaoLote : ' - ',
        class: 'detail-value'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.valorLanc'),
        value: row.VlLancamento ? maskThousand(row.VlLancamento) : '0,00',
        class: row.VlLancamento && row.VlLancamento > 0
          ? 'detail-value font-C'
          : row.VlLancamento && row.VlLancamento < 0
            ? 'detail-value font-D'
            : 'detail-value font-N'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.valorVendaBruto'),
        value: row.VLBRUTO ? maskThousand(row.VLBRUTO) : '0,00',
        class: row.VLBRUTO && row.VLBRUTO > 0
          ? 'detail-value font-C'
          : row.VLBRUTO && row.VLBRUTO < 0
            ? 'detail-value font-D'
            : 'detail-value font-N'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.valorVendaLiq'),
        value: row.VLLIQUIDO ? maskThousand(row.VLLIQUIDO) : '0,00',
        class: row.VLLIQUIDO && row.VLLIQUIDO > 0
          ? 'detail-value font-C'
          : row.VLLIQUIDO && row.VLLIQUIDO < 0
            ? 'detail-value font-D'
            : 'detail-value font-N'
      }
    ],
    idProcessamento: row.IdProcessamento
  }
}

const generateBankStatFromRow = (row) => {
  let $t = Vue.i18n.translate
  return {
    establishtmentValue: {
      title: $t('estabelecimentos.labels.estabelecimento'),
      value: row.Estabelecimento ? row.Estabelecimento : ' - '
    },
    mainValuesList: [
      {
        title: $t('modalDetalhesLanc.details.titulos.idlanc'),
        value: row.IdLancamento.toString()
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
        value: moment(row.DtLanc).utc().format('L')
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dtCont'),
        value: moment(row.DtContabil).utc().format('L')
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.banco'),
        value: row.Banco
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.agencia'),
        value: row.Agencia
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.nmConta'),
        value: row.NomeConta
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.nrConta'),
        value: row.NrConta
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dsTipo'),
        value: typeTranslate(row.Tipo)
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.cdHist'),
        value: row.CodHistorico
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dsHist'),
        value: row.DsHistorico
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dsDoc'),
        value: row.Documento
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.localizador'),
        value: row.Localizador
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.complemento'),
        value: row.Complemento
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.cdCat'),
        value: row.CodCategoria
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dsCat'),
        value: row.DsCategoria
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.bancoOrig'),
        value: row.BancoOrigem
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.agenciaOrig'),
        value: row.DsAgenciaOrigem
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.nrAgOrig'),
        value: row.NrAgenciaOrigem
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.processamento'),
        value: row.IdProcessamento ? row.IdProcessamento : ' - '
      }
    ],
    monetaryValuesList: [
      {
        title: $t('modalDetalhesLanc.details.titulos.vlDeb'),
        value: row.VlLancDeb ? maskThousand(row.VlLancDeb) : '0,00',
        class: row.VlLancDeb && row.VlLancDeb > 0
          ? 'detail-status font-C'
          : row.VlLancDeb && row.VlLancDeb < 0
            ? 'detail-status font-D'
            : 'detail-status font-N'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.vlCred'),
        value: row.VlLancCred ? maskThousand(row.VlLancCred) : '0,00',
        class: row.VlLancCred && row.VlLancCred > 0
          ? 'detail-status font-C'
          : row.VlLancCred && row.VlLancCred < 0
            ? 'detail-status font-D'
            : 'detail-status font-N'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.vlSaldo'),
        value: row.VlSaldo ? maskThousand(row.VlSaldo) : '0,00',
        class: row.VlSaldo && row.VlSaldo > 0
          ? 'detail-status font-C'
          : row.VlSaldo && row.VlSaldo < 0
            ? 'detail-status font-D'
            : 'detail-status font-N'
      }
    ],
    statusValuesList: [
      {
        title: $t('modalDetalhesLanc.details.titulos.statusConciliacao'),
        value: conciliationStatusTranslate(row.SituacaoConciliacao),
        class: 'detail-status font-' + (row.SituacaoConciliacao === 'M' ? 'C' : row.SituacaoConciliacao)
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.ocorrencia'),
        value: row.DSMotivoOcorrencia,
        class: 'detail-value'
      }
    ],
    integrationValuesList: [
      {
        title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
        value: moment(row.DtLanc).utc().format('L'),
        class: 'detail-value'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.statusConciliacao'),
        value: conciliationStatusTranslate(row.SituacaoConciliacao),
        class: 'detail-value font-' + (row.SituacaoConciliacao === 'M' ? 'C' : row.SituacaoConciliacao)
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.lote'),
        value: row.IdConciliacaoLote ? row.IdConciliacaoLote : ' - ',
        class: 'detail-value'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.vlDeb'),
        value: row.VlLancDeb ? maskThousand(row.VlLancDeb) : '0,00',
        class: row.VlLancDeb && row.VlLancDeb > 0
          ? 'detail-value font-C'
          : row.VlLancDeb && row.VlLancDeb < 0
            ? 'detail-value font-D'
            : 'detail-value font-N'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.vlCred'),
        value: row.VlLancCred ? maskThousand(row.VlLancCred) : '0,00',
        class: row.VlLancCred && row.VlLancCred > 0
          ? 'detail-value font-C'
          : row.VlLancCred && row.VlLancCred < 0
            ? 'detail-value font-D'
            : 'detail-value font-N'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.vlSaldo'),
        value: row.VlSaldo ? maskThousand(row.VlSaldo) : '0,00',
        class: row.VlSaldo && row.VlSaldo > 0
          ? 'detail-value font-C'
          : row.VlSaldo && row.VlSaldo < 0
            ? 'detail-value font-D'
            : 'detail-value font-N'
      }
    ],
    idProcessamento: row.IdProcessamento,
    classificationValuesList: [
      {
        title: $t('modalDetalhesLanc.details.titulos.idlanc'),
        value: row.IdLancamento.toString()
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
        value: moment(row.DtLanc).utc().format('L')
      },
      {
        title: row.VlLancCred ? $t('modalDetalhesLanc.details.titulos.vlCred') : $t('modalDetalhesLanc.details.titulos.vlDeb'),
        value: row.VlLancCred ? maskThousand(row.VlLancCred) : maskThousand(row.VlLancDeb)
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.cdHist'),
        value: row.CodHistorico
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dsHist'),
        value: row.DsHistorico
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.complemento'),
        value: row.Complemento
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.banco'),
        value: row.Banco
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.agencia'),
        value: row.Agencia
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.nrConta'),
        value: row.NrConta
      },
      {
        title: $t('modalDetalhesLanc.tabClassif.critClassif'),
        value: row.CritClassif
      }
    ]
  }
}

const generateFinMovFromNode = (item) => {
  let $t = Vue.i18n.translate
  let obj = {
    idMovimentoFinanceiro: item.id,
    concSituation: item.situacaoConciliacao,
    mainValuesList: [
      {
        title: $t('modalDetalhesLanc.details.titulos.idMovimento'),
        value: item.id
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
        value: moment(item.dataLancamento).utc().format('L')
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dtCont'),
        value: moment(item.dataContabil).utc().format('L')
      },
      {
        title: $t('estabelecimentos.labels.estabelecimento'),
        value: item.nomeFantasiaEstabelecimento ? item.nomeFantasiaEstabelecimento : ' - '
      },
      {
        title: $t('estabelecimentos.labels.grupoEstabelecimento'),
        value: item.nomeGrupoEstabelecimento ? item.nomeGrupoEstabelecimento : ' - '
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dsDoc'),
        value: item.documento ? item.documento : ' - '
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dsCat'),
        value: item.nomeCategoria ? item.nomeCategoria : ' - '
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.planoConciliacao'),
        value: item.nomePlanoConciliacao ? item.nomePlanoConciliacao : ' - '
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.valorLanc'),
        value: item.valorLancamento ? maskThousand(item.valorLancamento) : '0,00'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.valorOrigem'),
        value: item.valorOriginal ? maskThousand(item.valorOriginal) : '0,00',
        class: item.valorOriginal && item.valorOriginal > 0
          ? 'detail-status font-C'
          : item.valorOriginal && item.valorOriginal < 0
            ? 'detail-status font-D'
            : 'detail-status font-N'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.ocorrencia'),
        value: item.descricaoMotivoOcorrencia ? item.descricaoMotivoOcorrencia : ' - '
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.processamento'),
        value: item.idProcessamento ? item.idProcessamento : ' - '
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.nomeTarefa'),
        value: item.nomeUltimaTarefa ? item.nomeUltimaTarefa : ' - '
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.statusConciliacao'),
        value: conciliationStatusTranslate(item.situacaoConciliacao)
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.situacaoTarefa'),
        value: item.situacaoUltimaTarefa ? taskStatusesTranslate(item.situacaoUltimaTarefa) : ' - '
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dsTipo'),
        value: typeTranslate(item.tipoLancamento)
      }
    ],
    monetaryValuesList: [
      {
        title: $t('modalDetalhesLanc.details.titulos.valorLanc'),
        value: item.valorLancamento ? maskThousand(item.valorLancamento) : '0,00',
        class: item.valorLancamento && item.valorLancamento > 0
          ? 'detail-status font-C'
          : item.valorLancamento && item.valorLancamento < 0
            ? 'detail-status font-D'
            : 'detail-status font-N'
      }
    ],
    statusValuesList: [
      {
        title: $t('modalDetalhesLanc.details.titulos.statusConciliacao'),
        value: conciliationStatusTranslate(item.situacaoConciliacao),
        class: 'detail-status font-' + (item.situacaoConciliacao === 'M' ? 'C' : item.situacaoConciliacao)
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.ocorrencia'),
        value: item.descricaoMotivoOcorrencia ? item.descricaoMotivoOcorrencia : '-',
        class: 'detail-value'
      }
    ],
    integrationValuesList: [
      {
        title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
        value: moment(item.dataLancamento).utc().format('L'),
        class: 'detail-value'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.statusConciliacao'),
        value: conciliationStatusTranslate(item.situacaoConciliacao),
        class: 'detail-value font-' + (item.situacaoConciliacao === 'M' ? 'C' : item.situacaoConciliacao)
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.lote'),
        value: item.idLote ? item.idLote : ' - ',
        class: 'detail-value'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.valorLanc'),
        value: item.valorLancamento ? maskThousand(item.valorLancamento) : '0,00',
        class: item.valorLancamento && item.valorLancamento > 0
          ? 'detail-value font-C'
          : item.valorLancamento && item.valorLancamento < 0
            ? 'detail-value font-D'
            : 'detail-value font-N'
      }
    ],
    commentary: {
      title: $t('modalDetalhesLanc.details.titulos.comentario'),
      value: item.comentario ? item.comentario : ' - '
    },
    idProcessamento: item.idProcessamento
  }
  if (item && item.atributosValores && item.atributosValores.length > 0) {
    item.atributosValores.forEach(att => {
      switch (att.nome) {
        case 'IDEMPRESA':
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.idEmpresa'),
            value: att.valorOriginal ? att.valorOriginal : ' - '
          })
          break
        case 'CDBANCO':
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.banco'),
            value: att.valorOriginal ? att.valorOriginal : ' - '
          })
          break
        case 'DSCONTABANCARIA':
          obj.mainValuesList.push({
            title: $t('contaBancaria.titulos.contaBancaria'),
            value: att.valorOriginal ? att.valorOriginal : ' - '
          })
          break
        case 'FLIDENTIFICADO':
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.identificado'),
            value: att.valorOriginal ? att.valorOriginal : ' - '
          })
          break
        case 'NMADQUIRENTE':
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.adquirente'),
            value: att.valorOriginal ? att.valorOriginal : ' - '
          })
          break
        case 'NMBANDEIRA':
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.bandeira'),
            value: att.valorOriginal ? att.valorOriginal : ' - '
          })
          break
        case 'NMTIPOPRODUTO':
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.tipoProduto'),
            value: att.valorOriginal ? att.valorOriginal : ' - '
          })
          break
        case 'SGORIGEM':
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.origem'),
            value: att.valorOriginal ? att.valorOriginal : ' - '
          })
          break
        case 'NRLANCAMENTO':
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.lancCaixa'),
            value: att.valorOriginal ? att.valorOriginal : ' - '
          })
          break
        case 'NRTICKET':
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.nrTicket'),
            value: att.valorOriginal ? att.valorOriginal : ' - '
          })
          break
        case 'VLBRUTO':
          obj.monetaryValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.valorVendaBruto'),
            value: att.valorOriginal ? maskThousand(att.valorOriginal.replace(',', '.')) : '0,00',
            class: att.valorOriginal && att.valorOriginal > 0
              ? 'detail-status font-C'
              : att.valorOriginal && att.valorOriginal < 0
                ? 'detail-status font-D'
                : 'detail-status font-N'
          })
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.valorBruto'),
            value: att.valorOriginal ? maskThousand(att.valorOriginal.replace(',', '.')) : '0,00'
          })
          obj.integrationValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.valorVendaBruto'),
            value: att.valorOriginal ? maskThousand(parseFloat(att.valorOriginal)) : '0,00',
            class: att.valorOriginal && att.valorOriginal > 0
              ? 'detail-value font-C'
              : att.valorOriginal && att.valorOriginal < 0
                ? 'detail-value font-D'
                : 'detail-value font-N'
          })
          break
        case 'VLCOMISSAO':
          obj.mainValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.valorComissao'),
            value: att.valorOriginal ? maskThousand(att.valorOriginal.replace(',', '.')) : '0,00'
          })
          break
        case 'VLLIQUIDO':
          obj.monetaryValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.valorVendaLiq'),
            value: att.valorOriginal ? maskThousand(parseFloat(att.valorOriginal)) : '0,00',
            class: att.valorOriginal && att.valorOriginal > 0
              ? 'detail-status font-C'
              : att.valorOriginal && att.valorOriginal < 0
                ? 'detail-status font-D'
                : 'detail-status font-N'
          })
          obj.integrationValuesList.push({
            title: $t('modalDetalhesLanc.details.titulos.valorVendaLiq'),
            value: att.valorOriginal ? maskThousand(parseFloat(att.valorOriginal)) : '0,00',
            class: att.valorOriginal && att.valorOriginal > 0
              ? 'detail-value font-C'
              : att.valorOriginal && att.valorOriginal < 0
                ? 'detail-value font-D'
                : 'detail-value font-N'
          })
          break
      }
    })
  } else {
    obj.monetaryValuesList.push({
      title: $t('modalDetalhesLanc.details.titulos.valorVendaBruto'),
      value: '-',
      class: 'detail-status'
    })
    obj.integrationValuesList.push({
      title: $t('modalDetalhesLanc.details.titulos.valorVendaBruto'),
      value: '-',
      class: 'detail-value'
    })
    obj.monetaryValuesList.push({
      title: $t('modalDetalhesLanc.details.titulos.valorVendaLiq'),
      value: '-',
      class: 'detail-status'
    })
    obj.integrationValuesList.push({
      title: $t('modalDetalhesLanc.details.titulos.valorVendaLiq'),
      value: '-',
      class: 'detail-value'
    })
  }

  if (item && item.atributosValoresEstabelecimento && item.atributosValoresEstabelecimento.length > 0) {
    item.atributosValoresEstabelecimento.forEach(att => {
      obj.mainValuesList.push({
        title: att.descricao,
        value: att.valorOriginal ? att.valorOriginal : ' - '
      })
    })
  }

  return obj
}

const generateBankStatFromNode = (item) => {
  let $t = Vue.i18n.translate
  let monetary = {
    tipo: item.tipo,
    valor: item.valor
  }
  let itemValues = getValueByType(monetary)
  let labelCritClassif = null
  if (item.criterioClassificacao) {
    if (item.ordemCriterio) {
      labelCritClassif = item.ordemCriterio + ' - '
    }
    labelCritClassif += item.criterioClassificacao
  }

  return {
    idMovimentoBancario: item.id,
    establishtmentValue: {
      title: $t('estabelecimentos.labels.estabelecimento'),
      value: item.nomeFantasiaEstabelecimento ? item.nomeFantasiaEstabelecimento : ' - '
    },
    mainValuesList: [
      {
        title: $t('modalDetalhesLanc.details.titulos.idMovimento'),
        value: item.id
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
        value: moment(item.dataLancamento).utc().format('L')
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dtCont'),
        value: moment(item.dataContabil).utc().format('L')
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.banco'),
        value: item.codigoBanco + '-' + item.nomeFantasiaBanco
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.agencia'),
        value: item.numeroAgencia ? item.numeroAgencia : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.nmConta'),
        value: item.nomeConta ? item.nomeConta : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.nrConta'),
        value: item.numeroConta ? item.numeroConta : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dsTipo'),
        value: typeTranslate(item.tipo)
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.cdHist'),
        value: item.codigoHistorico
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dsHist'),
        value: item.descricaoHistorico
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dsDoc'),
        value: item.numeroDocumento ? item.numeroDocumento : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.localizador'),
        value: item.localizador ? item.localizador : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.complemento'),
        value: item.complemento ? item.complemento : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.cdCat'),
        value: item.codigoContaLancamentoCategoria
          ? item.codigoContaLancamentoCategoria
          : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dsCat'),
        value: item.descricaoContaLancamentoCategoria
          ? item.descricaoContaLancamentoCategoria
          : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.bancoOrig'),
        value: item.codigoBancoOrigem && item.nomeFantasiaBancoOrigem
          ? item.codigoBancoOrigem + '-' + item.nomeFantasiaBancoOrigem
          : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.agenciaOrig'),
        value: item.nomeAgenciaOrigem ? item.nomeAgenciaOrigem : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.nrAgOrig'),
        value: item.numeroAgenciaOrigem ? item.numeroAgenciaOrigem : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.processamento'),
        value: item.idProcessamento ? item.idProcessamento : ' - '
      }
    ],
    commentary: {
      title: $t('modalDetalhesLanc.details.titulos.comentario'),
      value: item.comentario ? item.comentario : ' - '
    },
    monetaryValuesList: [
      {
        title: $t('modalDetalhesLanc.details.titulos.vlDeb'),
        value: itemValues.debito ? maskThousand(itemValues.debito) : '0,00',
        class: itemValues.debito && itemValues.debito > 0
          ? 'detail-status font-C'
          : itemValues.debito && itemValues.debito < 0
            ? 'detail-status font-D'
            : 'detail-status font-N'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.vlCred'),
        value: itemValues.credito ? maskThousand(itemValues.credito) : '0,00',
        class: itemValues.credito && itemValues.credito > 0
          ? 'detail-status font-C'
          : itemValues.credito && itemValues.credito < 0
            ? 'detail-status font-D'
            : 'detail-status font-N'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.vlSaldo'),
        value: itemValues.saldo ? itemValues.saldo : '0,00',
        class: itemValues.saldo && itemValues.saldo > 0
          ? 'detail-status font-C'
          : itemValues.saldo && itemValues.saldo < 0
            ? 'detail-status font-D'
            : 'detail-status'
      }
    ],
    statusValuesList: [
      {
        title: $t('modalDetalhesLanc.details.titulos.statusConciliacao'),
        value: conciliationStatusTranslate(item.situacaoConciliacao),
        class: 'detail-status font-' + (item.situacaoConciliacao === 'M' ? 'C' : item.situacaoConciliacao)
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.ocorrencia'),
        value: item.descricaoMotivoOcorrencia ? item.descricaoMotivoOcorrencia : '-',
        class: 'detail-value'
      }
    ],
    integrationValuesList: [
      {
        title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
        value: moment(item.dataLancamento).utc().format('L'),
        class: 'detail-value'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.statusConciliacao'),
        value: conciliationStatusTranslate(item.situacaoConciliacao),
        class: 'detail-value font-' + (item.situacaoConciliacao === 'M' ? 'C' : item.situacaoConciliacao)
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.lote'),
        value: item.idLote ? item.idLote : '-',
        class: 'detail-value'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.vlDeb'),
        value: itemValues.debito ? maskThousand(itemValues.debito) : '0,00',
        class: itemValues.debito && itemValues.debito > 0
          ? 'detail-value font-C'
          : itemValues.debito && itemValues.debito < 0
            ? 'detail-value font-D'
            : 'detail-value font-N'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.vlCred'),
        value: itemValues.credito ? maskThousand(itemValues.credito) : '0,00',
        class: itemValues.credito && itemValues.credito > 0
          ? 'detail-value font-C'
          : itemValues.credito && itemValues.credito < 0
            ? 'detail-value font-D'
            : 'detail-value font-N'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.vlSaldo'),
        value: itemValues.saldo ? itemValues.saldo : '0,00',
        class: itemValues.saldo && itemValues.saldo > 0
          ? 'detail-value font-C'
          : itemValues.saldo && itemValues.saldo < 0
            ? 'detail-value font-D'
            : 'detail-value'
      }
    ],
    idProcessamento: item.idProcessamento,
    classificationValuesList: [
      {
        title: $t('modalDetalhesLanc.details.titulos.idlanc'),
        value: item.idContaLancamento
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
        value: moment(item.dataLancamento).utc().format('L')
      },
      {
        title: itemValues.credito ? $t('modalDetalhesLanc.details.titulos.vlCred') : $t('modalDetalhesLanc.details.titulos.vlDeb'),
        value: itemValues.credito ? maskThousand(itemValues.credito) : maskThousand(itemValues.debito)
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.cdHist'),
        value: item.codigoHistorico
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dsHist'),
        value: item.descricaoHistorico
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.complemento'),
        value: item.complemento
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.banco'),
        value: item.codigoBanco + '-' + item.nomeFantasiaBanco
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.agencia'),
        value: item.numeroAgencia ? item.numeroAgencia : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.nrConta'),
        value: item.numeroConta ? item.numeroConta : '-'
      },
      {
        title: $t('modalDetalhesLanc.tabClassif.critClassif'),
        value: labelCritClassif
      }
    ]
  }
}

const generateAccountEntryFromNode = (item) => {
  let $t = Vue.i18n.translate
  let itemValues = getValueByType(item)
  return {
    establishtmentValue: {
      title: $t('estabelecimentos.labels.estabelecimento'),
      value: item.estabelecimento ? item.estabelecimento.nome : ' - '
    },
    mainValuesList: [
      {
        title: $t('modalDetalhesLanc.details.titulos.idlanc'),
        value: item.id
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
        value: moment(item.dataLancamento).utc().format('L')
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dtCont'),
        value: moment(item.dataContabil).utc().format('L')
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.banco'),
        value: item.codigoBanco && item.nomeFantasiaBanco ? item.codigoBanco + '-' + item.nomeFantasiaBanco : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.agencia'),
        value: item.numeroAgencia ? item.numeroAgencia : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.nmConta'),
        value: item.nomeConta ? item.nomeConta : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.nrConta'),
        value: item.numeroConta ? item.numeroConta : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dsTipo'),
        value: typeTranslate(item.tipo)
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.cdHist'),
        value: item.codigoHistorico
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dsHist'),
        value: item.descricaoHistorico
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dsDoc'),
        value: item.numeroDocumento ? item.numeroDocumento : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.complemento'),
        value: item.complemento ? item.complemento : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.cdCat'),
        value: item.codigoContaLancamentoCategoria ? item.codigoContaLancamentoCategoria : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.dsCat'),
        value: item.descricaoContaLancamentoCategoria ? item.descricaoContaLancamentoCategoria : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.bancoOrig'),
        value: item.codigoBancoOrigem ? item.codigoBancoOrigem + '-' + item.nomeFantasiaBancoOrigem : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.agenciaOrig'),
        value: item.nomeAgenciaOrigem ? item.nomeAgenciaOrigem : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.nrAgOrig'),
        value: item.numeroAgenciaOrigem ? item.numeroAgenciaOrigem : '-'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.processamento'),
        value: item.idProcessamento ? item.idProcessamento : ' - '
      }
    ],
    monetaryValuesList: [
      {
        title: $t('modalDetalhesLanc.details.titulos.vlDeb'),
        value: itemValues.debito ? maskThousand(itemValues.debito) : '0,00',
        class: itemValues.debito && itemValues.debito > 0
        ? 'detail-status font-C'
        : itemValues.debito && itemValues.debito < 0
        ? 'detail-status font-D'
        : 'detail-status font-N'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.vlCred'),
        value: itemValues.credito ? maskThousand(itemValues.credito) : '0,00',
        class: itemValues.credito && itemValues.credito > 0
        ? 'detail-status font-C'
        : itemValues.credito && itemValues.credito < 0
        ? 'detail-status font-D'
        : 'detail-status font-N'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.vlSaldo'),
        value: itemValues.saldo ? itemValues.saldo : '0,00',
        class: itemValues.saldo && itemValues.saldo > 0
        ? 'detail-status font-C'
        : itemValues.saldo && itemValues.saldo < 0
        ? 'detail-status font-D'
        : 'detail-status'
      }
    ],
    integrationValuesList: [
      {
        title: $t('modalDetalhesLanc.details.titulos.dtLanc'),
        value: moment(item.dataLancamento).utc().format('L'),
        class: 'detail-value'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.lote'),
        value: item.lote ? item.lote.id : '-',
        class: 'detail-value'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.vlDeb'),
        value: itemValues.debito ? maskThousand(itemValues.debito) : '0,00',
        class: itemValues.debito && itemValues.debito > 0
        ? 'detail-value font-C'
        : itemValues.debito && itemValues.debito < 0
        ? 'detail-value font-D'
        : 'detail-value font-N'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.vlCred'),
        value: itemValues.credito ? maskThousand(itemValues.credito) : '0,00',
        class: itemValues.credito && itemValues.credito > 0
        ? 'detail-value font-C'
        : itemValues.credito && itemValues.credito < 0
        ? 'detail-value font-D'
        : 'detail-value font-N'
      },
      {
        title: $t('modalDetalhesLanc.details.titulos.vlSaldo'),
        value: itemValues.saldo ? itemValues.saldo : '0,00',
        class: itemValues.saldo && itemValues.saldo > 0
        ? 'detail-value font-C'
        : itemValues.saldo && itemValues.saldo < 0
        ? 'detail-value font-D'
        : 'detail-value'
      }
    ],
    idProcessamento: item.idProcessamento
  }
}

export {
  generateFinMovFromRow,
  generateBankStatFromRow,
  generateFinMovFromNode,
  generateBankStatFromNode,
  generateAccountEntryFromNode
}



// WEBPACK FOOTER //
// ./client/utils/transformationData.js